import { createSlice, createAsyncThunk, isAction } from "@reduxjs/toolkit";
import { message } from "antd";
import { API_BASE_URL } from "../config";
import { setError } from "./errorSlice";

export const fetchTerms = createAsyncThunk(
  "schedule/fetchTerms",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(`${API_BASE_URL}/api/Term`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Fetched Terms:", data);

      if (data.length === 0) {
        message.warning("No terms found");
      }
      return data;
    } catch (error) {
      console.error("Error fetching terms:", error);
      dispatch(setError("Error fetching terms", error.message));
      return rejectWithValue("Error fetching terms.", error.message);
   }
  }
);
export const fetchScheduleData = createAsyncThunk(
  "schedule/fetchScheduleData",
  async (termID, { rejectWithValue, dispatch }) => {
    try {
      console.log("ScheduleSlot/check-schedule response", termID);
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/ScheduleSlot/check-schedule?termID=${termID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch schedule data");
      const data = await response.json();
      console.log("ScheduleSlot/check-schedule response", data);
      return true;
    } catch (error) {
      return rejectWithValue(false);
   }
  }
);
export const generateScheduleData = createAsyncThunk(
  "schedule/generateScheduleData",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      console.log("payload", payload);
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/ScheduleSlot/generate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) throw new Error("Failed to fetch schedule data");
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching schedule data:", error);
      dispatch(setError("Error fetching schedule data", error));
      return rejectWithValue("Error fetching schedule data.", error);
    }
  }
);
export const fetchTeachersSchedule = createAsyncThunk(
  "schedule/fetchTeachersSchedule",
  async (termID, { rejectWithValue, dispatch }) => {
    try {
      console.log("termID", termID);
      console.log("termID", JSON.stringify({ termID }));
      console.log("termID", JSON.stringify(termID));

 
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/ScheduleSlot/teachers?termID=${termID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );
      if (!response.ok) throw new Error("Failed to fetch schedule data");
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching schedule data:", error);
      dispatch(setError("Error fetching schedule data", error));
      return rejectWithValue("Error fetching schedule data.", error);
    }
  }
);
export const fetchSectionsSchedule = createAsyncThunk(
  "schedule/fetchSectionsSchedule",
  async (termID, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/ScheduleSlot/sections?termID=${termID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );
      if (!response.ok) throw new Error("Failed to fetch schedule data");
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching schedule data:", error);
     dispatch(setError("Error fetching schedule data", error));
      return rejectWithValue("Error fetching schedule data.", error);
   }
  }
);
export const fetchSchoolSchedule = createAsyncThunk(
  "schedule/fetchSchoolSchedule",
  async (termID, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/ScheduleSlot/schools/${termID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );
      if (!response.ok) throw new Error("Failed to fetch schedule data");
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching schedule data:", error);
      dispatch(setError("Failed to load schedule data", error));
      return rejectWithValue("Failed to load schedule data.", error);

    }
  }
);

const scheduleDataSlice = createSlice({
  name: "scheduleData",
  initialState: {
    terms: [],
    scheduleData: [],
    teachersScheduleData: [],
    sectionsScheduleData: [],
    schoolsScheduleData: [],
    isTermScheduled: false,

    loading: false,
    error: null,
  },
  reducer: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTerms.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTerms.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.terms = action.payload;
      })
      .addCase(fetchTerms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchTeachersSchedule.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeachersSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.teachersScheduleData = action.payload;
        console.log("state.teachersScheduleData", state.teachersScheduleData);
      })
      .addCase(fetchTeachersSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSectionsSchedule.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSectionsSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.sectionsScheduleData = action.payload;
      })
      .addCase(fetchSectionsSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSchoolSchedule.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSchoolSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.schoolsScheduleData = action.payload;
      })
      .addCase(fetchSchoolSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchScheduleData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchScheduleData.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
         state.isTermScheduled =  true;
      })
      .addCase(fetchScheduleData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isTermScheduled = false;
      })
      .addCase(generateScheduleData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateScheduleData.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        console.log("generateScheduleData action.payload ", action.payload);
        state.isTermScheduled = action.payload?.totalCount >= 0 ? true : true;
      })
      .addCase(generateScheduleData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isTermScheduled = false;
      });

    //
  },
});

export default scheduleDataSlice.reducer;
